import { TActivityInfo } from "@/types/activity";

const ACTIVITY_TYPE: Record<string, string> = {
  PLAYER_ADDED_TO_WATCHLIST: "PLAYER_ADDED_TO_WATCHLIST",
  PLAYER_REMOVED_FROM_WATCHLIST: "PLAYER_REMOVED_FROM_WATCHLIST",
  PLAYER_RATING_UPDATED: "PLAYER_RATING_UPDATED",
  PLAYER_ANALYSIS_UPDATED: "PLAYER_ANALYSIS_UPDATED",
  SCOUT_REPORT_CREATED: "SCOUT_REPORT_CREATED",
  SCOUT_REPORT_UPDATED: "SCOUT_REPORT_UPDATED",
  SCOUT_REPORT_SHARED: "SCOUT_REPORT_SHARED",
  CONTENT_SHARED: "CONTENT_SHARED",
  USER_JOINED_ORGANIZATION: "USER_JOINED_ORGANIZATION",
  USER_LEFT_ORGANIZATION: "USER_LEFT_ORGANIZATION",
  NOTE_CREATED: "NOTE_CREATED",
  NOTE_SHARED: "NOTE_SHARED",
  NOTE_VISIBILITY_CHANGED: "NOTE_VISIBILITY_CHANGED",
  USER_SIGNED_IN: "USER_SIGNED_IN",
  USER_SIGNED_OUT: "USER_SIGNED_OUT",
  MANUAL_PLAYER_CREATED: "MANUAL_PLAYER_CREATED",
  MANUAL_PLAYER_UPDATED: "MANUAL_PLAYER_UPDATED",
  MANUAL_PLAYER_DELETED: "MANUAL_PLAYER_DELETED",
  MANUAL_PLAYER_RESTORED: "MANUAL_PLAYER_RESTORED",
  MANUAL_PLAYER_DATA_TRANSFERRED: "MANUAL_PLAYER_DATA_TRANSFERRED",
  MATCH_REPORT_SUBMITTED: "MATCH_REPORT_SUBMITTED",
};

export /**
 *
 */
const handleDeeplinkNavigation = (
  activityInfo: TActivityInfo,
  executeAction: Function
) => {
  const { activityType, playerId, deepLink } = activityInfo ?? {};

  if (activityType) {
    // SE-5196: share activities point at a specific report/note, not just a
    // player. The player page can't be reconstructed into that target from
    // playerId alone, so honor the server-provided deepLink (e.g.
    // /players/{playerId}/reports?reportId={reportId}) when present. Falls
    // through to the player-page logic below if no deepLink was supplied
    // (e.g. the native push path, which doesn't carry one yet).
    const DEEP_LINK_TYPES = [
      ACTIVITY_TYPE.CONTENT_SHARED,
      ACTIVITY_TYPE.SCOUT_REPORT_SHARED,
      ACTIVITY_TYPE.NOTE_SHARED,
      // SE-6988: match report submissions navigate to the server-provided
      // /match-reports/{id} link; without one the tap is a no-op below
      // (there is no player-page fallback for a report).
      ACTIVITY_TYPE.MATCH_REPORT_SUBMITTED,
    ];
    if (DEEP_LINK_TYPES.includes(activityType) && deepLink) {
      executeAction?.(deepLink);
      return;
    }

    switch (activityType) {
      case ACTIVITY_TYPE.PLAYER_ADDED_TO_WATCHLIST:
      case ACTIVITY_TYPE.PLAYER_REMOVED_FROM_WATCHLIST:
      case ACTIVITY_TYPE.PLAYER_RATING_UPDATED:
      case ACTIVITY_TYPE.PLAYER_ANALYSIS_UPDATED:
      case ACTIVITY_TYPE.SCOUT_REPORT_CREATED:
      case ACTIVITY_TYPE.SCOUT_REPORT_UPDATED:
      case ACTIVITY_TYPE.SCOUT_REPORT_SHARED:
      case ACTIVITY_TYPE.CONTENT_SHARED:
      case ACTIVITY_TYPE.NOTE_CREATED:
      case ACTIVITY_TYPE.NOTE_SHARED:
      case ACTIVITY_TYPE.NOTE_VISIBILITY_CHANGED:
      case ACTIVITY_TYPE.MANUAL_PLAYER_CREATED:
      case ACTIVITY_TYPE.MANUAL_PLAYER_UPDATED:
      case ACTIVITY_TYPE.MANUAL_PLAYER_RESTORED:
      case ACTIVITY_TYPE.MANUAL_PLAYER_DATA_TRANSFERRED:
        if (!playerId) {
          console.warn(
            `Activity ${activityType} missing playerId, skipping navigation`
          );
          break;
        }
        executeAction?.(`/players/${playerId}`);
        break;
      case ACTIVITY_TYPE.USER_JOINED_ORGANIZATION:
      case ACTIVITY_TYPE.USER_LEFT_ORGANIZATION:
        executeAction?.("/organizations");
        break;
      default:
        break;
    }
  } else {
    console.warn("Invalid deeplink");
  }
};
